import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AbstractBaseService } from '../../../../Services/AbstractBaseService';
import { environment } from '../../../../../environments/environment';
import { User } from '../../models';

@Injectable({ providedIn: 'root' })
export class AuthenticationService extends AbstractBaseService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private http: HttpClient) {
        super();
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(Email: string, Password: string) {
        return this.http.post<any>(environment.getApiUrl('mdms','mdms','login'), { Email, Password })
            .pipe(map(user => {
                // login successful if there's a jwt token in the response
                if (user && user.data.token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user.data));
                    localStorage.setItem('token', JSON.stringify(user.data.token));
                    this.currentUserSubject.next(user.data);
                }

                return user;
            }));
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }
}